import React from "react";

const LazyMeetingAgendaItems = React.lazy(() =>
  import("./MeetingAgendaItems").then((module) => ({ default: module.MeetingAgendaItems }))
);

export default LazyMeetingAgendaItems;
